var map = {
	"./": 481,
	"./OldUi": 2715,
	"./OldUi.js": 2715,
	"./SpireonNew": 2716,
	"./SpireonNew.js": 2716,
	"./SpireonOld": 2717,
	"./SpireonOld.js": 2717,
	"./index": 481,
	"./index.js": 481,
	"./style": 373,
	"./style.js": 373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4231;